module.exports = __webpack_public_path__ + "static/leaves-524e21da5a651f1fabb21e73da9f36f3.jpg";